import { Plus } from "lucide-react";

export function RemindersPageHeader({ onAddClick }) {
  return (
    <div className="bg-white border-b border-gray-200 px-4 py-4 md:px-8 md:py-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl md:text-3xl font-semibold text-gray-900">
            Reminders
          </h1>
          <p className="text-sm text-gray-600 mt-1">
            Track what's about to go bad
          </p>
        </div>

        <button
          onClick={onAddClick}
          className="px-4 py-2.5 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors flex items-center gap-2 whitespace-nowrap"
        >
          <Plus className="w-4 h-4" />
          <span className="hidden sm:inline">Add reminder</span>
          <span className="sm:hidden">Add</span>
        </button>
      </div>
    </div>
  );
}
